import { AuthenticatedCachedRepository, AuthenticatedHttpClient } from "../..";
import { IProjectTeamRepository, ProjectTeam } from "../../../domain/projectTeam";
import { ProjectTeamTranslator } from ".";

export class ProjectTeamRepository extends AuthenticatedCachedRepository<number, ProjectTeam> implements IProjectTeamRepository {
  constructor(getToken: () => string) {
    super(new AuthenticatedHttpClient(getToken), ProjectTeamRepository.createCache);
  }

  private static async createCache(client: AuthenticatedHttpClient): Promise<ProjectTeam[]> {
    const url = "/api/projectteams";
    const result = await client.get(url);
    const translator = new ProjectTeamTranslator();
    return translator.toProjectTeams(result.data);
  }
}
